import { brand } from '@/styles/shared';

interface PlayIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const PlayIcon: React.FC<PlayIconProps> = ({
  width = 108,
  height = 108,
  fill = brand.greenPrimary,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 108 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id="filter0_d_2415_1825"
          x="0.75"
          y="0.75"
          width="106.5"
          height="106.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_2415_1825"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.47451  0 0 0 0 0.764706  0 0 0 0 0.0117647  0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2415_1825"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2415_1825"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter0_d_2415_1825)">
        <circle
          cx="54"
          cy="54"
          r="42"
          fill="#ffffff"
          shapeRendering="crispEdges"
        />
        <circle
          cx="54"
          cy="54"
          r="42"
          stroke={fill}
          strokeOpacity="0.5"
          strokeWidth="0.5"
          shapeRendering="crispEdges"
          fill="none"
        />
      </g>

      <path
        d="M67.2 54L49.8462 64.8554L48 66V42L67.2 54ZM63.6923 54L49.8462 45.3231V62.6769L63.6923 54Z"
        fill={fill}
        fillOpacity="0.8"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default PlayIcon;
